import {getCalls, updateCall} from "../helpers/callsService";
import {checkError, closeAlert, receiveErrorAlert, receiveSuccessAlert} from "./commonsActions";

export const FETCH_CALLS_BEGIN   = 'FETCH_CALLS_BEGIN';
export const FETCH_CALLS_SUCCESS = 'FETCH_CALLS_SUCCESS';
export const FETCH_CALLS_ERROR = 'FETCH_CALLS_ERROR';


export const fetchCalls = query => dispatch => {
    dispatch({
        type: FETCH_CALLS_BEGIN
    });
    return getCalls(query).then(res => {
        dispatch({
            type: FETCH_CALLS_SUCCESS,
            payload: {
                calls: res.data,
                numberOfElements : res.numberOfElements,
                totalElements: res.totalElements,
                totalPages: res.totalPages
            }
        });
        return res
    }, error => {
        dispatch({
            type: FETCH_CALLS_ERROR
        });
        dispatch(checkError(error));
        dispatch(receiveErrorAlert(error));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
    })
};

export const updateSingleCall = (query) => dispatch => {
    return updateCall(query).then(res => {
        dispatch(receiveSuccessAlert('Update Successful'));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
        return res;
    }, error => {
        dispatch(checkError(error));
        dispatch(receiveErrorAlert(error));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
    })
};


// WEBPACK FOOTER //
// ./src/actions/callsActions.js